import React, { useEffect, useState } from 'react'
import { Checkbox, Col, Form, FormInstance, Row, Select } from 'antd'
import { BroadcastFormValues } from 'component/Broadcast/BroadcastDetails'

const { Item } = Form

interface Props {
	form: FormInstance<BroadcastFormValues>
	canEditBroadcast: boolean
}

const BroadcastLegacyFormSettings: React.FC<Props> = ({
	form,
	canEditBroadcast,
}) => {
	const [reRender, setReRender] = useState(false)

	const triggerRender = () => {
		setReRender(true)
	}

	useEffect(() => {
		if (reRender) {
			setReRender(false)
		}
	}, [reRender])

	return (
		<>
			<p className='custom-label'>Auto assign engagement</p>
			<Row gutter={16}>
				<Col span={8}>
					<Item name='autoAssignType'>
						<Select
							placeholder='Select Team or Agent'
							options={[
								{
									label: 'Team',
									value: 'TEAM',
								},
								{
									label: 'Agent',
									value: 'AGENT',
								},
							]}
							optionFilterProp='label'
							onChange={triggerRender}
							allowClear
							showSearch
							disabled={!canEditBroadcast}
						/>
					</Item>
				</Col>
				<Col span={8}>
					<Item
						hidden={form.getFieldValue('autoAssignType') !== 'TEAM'}
						name='autoAssignTeam'
						rules={[
							{
								required: true,
								message: 'Select Team!',
							},
						]}
					>
						<Select
							placeholder='Select Team'
							optionFilterProp='label'
							showSearch
							disabled={!canEditBroadcast}
						/>
					</Item>
					<Item
						hidden={form.getFieldValue('autoAssignType') !== 'AGENT'}
						name='autoAssignAgents'
					>
						<Select
							placeholder='Select Agent'
							maxTagCount={1}
							mode='multiple'
							optionFilterProp='label'
							showSearch
							disabled={!canEditBroadcast}
						/>
					</Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={8}>
					<Item
						name='tags'
						label='Auto assign tag to contacts that reply to this broadcast'
					>
						<Select
							placeholder='Select Tags'
							mode='multiple'
							maxTagCount={1}
							optionFilterProp='label'
							showSearch
							disabled={!canEditBroadcast}
						/>
					</Item>
					<Item name='enquiry' valuePropName='checked'>
						<Checkbox disabled={!canEditBroadcast}>
							Register an enquiry on response.
						</Checkbox>
					</Item>

					{/* <Item label='Default response to Broadcast Message' name='defaultMessage'> */}
					{/*	<MessageComposer */}
					{/*		placeholder='Type Something...' */}
					{/*		name='welcomeMessage' */}
					{/*		disabled={!canEditBroadcast} */}
					{/*	/> */}
					{/* </Item> */}
				</Col>
			</Row>
		</>
	)
}

export default BroadcastLegacyFormSettings
